import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ExaminadorProvaStatus {
  nome: string;
  notasDigitadas: number;
  totalInscricoes: number;
  envelopeEnviado: boolean;
}

export interface PendenciasProvaEmAndamento {
  tipoProva: string;
  examinadores: ExaminadorProvaStatus[];
  reportesPendentes?: number;
  concursoId?: number;
}

@Component({
  selector: 'inscricoes-modal-pendencias-prova-andamento',
  templateUrl: './modal-pendencias-prova-andamento.component.html',
  styleUrls: ['./modal-pendencias-prova-andamento.component.scss']
})
export class ModalPendenciasProvaAndamentoComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalPendenciasProvaAndamentoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PendenciasProvaEmAndamento
  ) {}

  fechar(): void {
    this.dialogRef.close();
  }

  getProgressoPercentual(examinador: ExaminadorProvaStatus): number {
    if (examinador.totalInscricoes === 0) return 0;
    return Math.round((examinador.notasDigitadas / examinador.totalInscricoes) * 100);
  }

  temPendencias(): boolean {
    return this.data.examinadores.some(e => 
      e.notasDigitadas < e.totalInscricoes || !e.envelopeEnviado
    );
  }

  getNomeProva(tipoProva: string): string {
    const nomes: { [key: string]: string } = {
      'DIDATICA': 'Prova Didática',
      'ESCRITA': 'Prova Escrita',
      'ARGUICAO': 'Prova de Arguição',
      'TITULOS': 'Prova de Títulos',
      'ESPECIFICA': 'Prova Específica',
      'PLANO': 'Análise do Plano de Trabalho'
    };
    return nomes[tipoProva] || tipoProva;
  }
}
